"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { AppRole } from "@/shared/store/authStore";

export type AppAuthSnapshot = {
  hasHydrated: boolean;
  isAuthenticated: boolean;
  isAuthRouting: boolean;
  isLogoutPending: boolean;
  role: AppRole | null;
  setLogoutPending: (pending: boolean) => void;
};

const AppAuthSnapshotContext = createContext<AppAuthSnapshot | null>(null);

export function AppAuthSnapshotProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: AppAuthSnapshot;
}) {
  return <AppAuthSnapshotContext.Provider value={value}>{children}</AppAuthSnapshotContext.Provider>;
}

export function useAppAuthSnapshot() {
  const value = useContext(AppAuthSnapshotContext);

  if (!value) {
    throw new Error("useAppAuthSnapshot must be used within AppAuthSnapshotProvider");
  }

  return value;
}
